export default function Contact() {

  const sendWhatsApp = () => {
    const msg = "Hello, I want to enquire about car rental services.";
    const whatsappNumber = "919052885299"; // CHANGE to your number
    window.open(`https://wa.me/${whatsappNumber}?text=${encodeURIComponent(msg)}`, "_blank");
  };

  return (
    <>
      {/* HEADER */}
      <section className="contact-header">
        <h1>Contact Us</h1>
        <p>We are always ready to help you with your travel needs</p>
      </section>

      {/* CONTACT INFO */}
      <section className="glass-section contact-section">
        <div className="contact-grid">

          {/* LEFT - DETAILS */}
          <div className="contact-info">
            <h2>Get in Touch</h2>
            <p>📍 Location: Tirupati, Andhra Pradesh</p>
            <p>📞 Phone: +91 9052885299</p>
            <p>✉ Email: cherryselfdrivecars@gmail.com</p>

            <button className="btn-gradient" onClick={sendWhatsApp}>
              Chat on WhatsApp
            </button>
          </div>

          {/* RIGHT - FORM */}
          <div className="contact-form">
            <h2>Send Message</h2>
            <input type="text" placeholder="Your Name" />
            <input type="email" placeholder="Your Email" />
            <textarea rows="4" placeholder="Your Message"></textarea>
            <button className="btn-gradient">Send Message</button>
          </div>
        </div>
      </section>

      {/* MAP */}
      <section className="map-section">
        <iframe
          title="map"
          src="https://www.google.com/maps?q=Tirupati&output=embed"
          width="100%"
          height="350"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
        ></iframe>
      </section>
    </>
  );
}
